import React from 'react';
import uniqueId from 'lodash/uniqueId';
import ValidationControl from '../ValidationControl/ValidationControl';
import CheckBoxControl from './CheckBoxControl';

interface IProps {
  name: string;
  value: boolean;
  onChange?: (event: any) => void;
  isReadonly: boolean;
  isRequired?: boolean;
  isValid?: boolean;
  validationMessage?: string;
}

export class CheckBoxControlObject extends React.Component<IProps> {
  private uid = uniqueId('checkbox_');
  public render() {
    return (
      <table>
        <tbody>
          <tr>
            <td>
              <ValidationControl
                {...this.props}
                isValid={this.props.isValid !== undefined ? this.props.isValid : true}
                message={this.props.validationMessage ? this.props.validationMessage : 'An input is required'}
                uid={this.uid}
              />
            </td>
            <td>
              <CheckBoxControl {...this.props} />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default CheckBoxControlObject;
